/*Import Estilo*/
import './index.scss';
import '../../css/global.css';
import '../../css/normalize.css';

/*Import Bibliotecas*/
import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

/*Import Componentes*/
import Cabecalho from '../../components/Cabecalho';
import Rodape from '../../components/Rodape';
import CookieAceite from '../../components/CookieAceite';
import { validadorEmail } from '../../utils/Validadores';

/*Import Requisição API*/
import api from '../../api';

export default function EsqueciaASenha() {

    /* Variaveis para enviar ao banco de dados */

    const [email, setEmail] = useState('');

    /* Validadores variaveis */

    const [emailValido, setEmailValido] = useState(null);

    /* Outros */

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    /* Caixas de dialogo */

    const [texto, setTexto] = useState('');
    const [modalAberto, setModalAberto] = useState(false);
    const caixaDeDialogo = useRef(null);

    useEffect(() => {
        caixaDeDialogo.current = document.getElementById("CaixaDeDialogo");
        console.log(caixaDeDialogo.current);
    }, []);

    const fecharModal = () => {
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.close();
        }
    };

    const mostrarModal = () => {
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.showModal();
        }
    };

    /* Fim caixas de Dialogo */

    const handleEmailChange = (e) => {
        const valor = e.target.value;
        setEmail(valor);
        const emailValido = valor !== '' ? validadorEmail(valor) : null;
        setEmailValido(emailValido);
    };

    const enviarCodigoRecuperacaoSenha = () => {
        if (!email) {
            setTexto("Preencha o campo de e-mail para prosseguir.");
            mostrarModal();
        } else if (!validadorEmail(email)) {
            setTexto("Por favor, insira um e-mail válido.");
            mostrarModal();
        } else {
            handlePasswordResetRequest();
        }
    };

    const handlePasswordResetRequest = async () => {
        setLoading(true);
        try {
            const response = await api.post('/requisicao-resetar-senha', { email });
            setTexto(response.data.message || 'Verifique seu e-mail para redefinir sua senha.');
            navigate('/inserir-codigo', { state: { email } });
            mostrarModal();
        } catch (error) {
            setTexto(error.response?.data.message || 'Ocorreu um erro. Tente novamente.');
            mostrarModal();
        } finally {
            setLoading(false);
        }
    };

    const irParaInserirCodigo = () => {
        if (emailValido) {
            navigate('/inserir-codigo', { state: { email } });
        } else {
            setTexto("Por favor, insira um e-mail válido antes de prosseguir.");
            mostrarModal();
        }
    };

    return (
        <section className='containerPrincipalEsqueciASenha'>
            <Cabecalho />

            <CookieAceite />

            <dialog id="CaixaDeDialogo" className={modalAberto ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className="dialog-texto">
                        <p>{texto}</p>
                        <button id="botao" onClick={fecharModal}>
                            Ok
                        </button>
                    </div>
                </div>
            </dialog>

            <main>
                <section className='conteudo-MainEsqueciASenha'>
                    {loading ? (
                        <div className="loading">
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24"><path fill="#fff" d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity="0.25" /><path fill="#fff" d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z"><animateTransform attributeName="transform" dur="0.75s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12" /></path></svg>
                            <h2>Carregando</h2>
                        </div>
                    ) : (
                        <>
                            <ul class="iconResetPassword">
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                            </ul>

                            <div className='box-EsqueciASenhaEmail'>
                                <h1>Esqueceu sua senha?</h1>
                                <h2>Fique tranquilo, estamos aqui para ajudar! Por favor, informe seu e-mail para recuperar seu acesso.</h2>
                                <form>
                                    <label className='label-Email' htmlFor="email">E-mail:</label>
                                    <div className={`container-Email ${emailValido === null ? '' : emailValido ? 'valido' : 'invalido'}`}>
                                        <svg className='iconEmail' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88334 20.6867 5.825 19.9743 4.925 19.075C4.025 18.1757 3.31267 17.1173 2.788 15.9C2.26333 14.6827 2.00067 13.3827 2 12C1.99933 10.6173 2.262 9.31733 2.788 8.1C3.314 6.88267 4.02633 5.82433 4.925 4.925C5.82367 4.02567 6.882 3.31333 8.1 2.788C9.318 2.26267 10.618 2 12 2C13.382 2 14.682 2.26267 15.9 2.788C17.118 3.31333 18.1763 4.02567 19.075 4.925C19.9737 5.82433 20.6863 6.88267 21.213 8.1C21.7397 9.31733 22.002 10.6173 22 12V13.45C22 14.4333 21.6627 15.271 20.988 15.963C20.3133 16.655 19.484 17.0007 18.5 17C17.9167 17 17.3667 16.875 16.85 16.625C16.3333 16.375 15.9 16.0167 15.55 15.55C15.0667 16.0333 14.5207 16.396 13.912 16.638C13.3033 16.88 12.666 17.0007 12 17C10.6167 17 9.43767 16.5123 8.463 15.537C7.48834 14.5617 7.00067 13.3827 7 12C6.99933 10.6173 7.487 9.43833 8.463 8.463C9.439 7.48767 10.618 7 12 7C13.382 7 14.5613 7.48767 15.538 8.463C16.5147 9.43833 17.002 10.6173 17 12V13.45C17 13.8833 17.1417 14.25 17.425 14.55C17.7083 14.85 18.0667 15 18.5 15C18.9333 15 19.2917 14.85 19.575 14.55C19.8583 14.25 20 13.8833 20 13.45V12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20H17V22H12ZM12 15C12.8333 15 13.5417 14.7083 14.125 14.125C14.7083 13.5417 15 12.8333 15 12C15 11.1667 14.7083 10.4583 14.125 9.875C13.5417 9.29167 12.8333 9 12 9C11.1667 9 10.4583 9.29167 9.875 9.875C9.29167 10.4583 9 11.1667 9 12C9 12.8333 9.29167 13.5417 9.875 14.125C10.4583 14.7083 11.1667 15 12 15Z" />
                                        </svg>
                                        <svg className='barra' width="3" height="26" viewBox="0 0 3 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1.5 1L1.5 25" stroke-width="2" stroke-linecap="round" />
                                        </svg>
                                        <input
                                            id="email"
                                            maxLength={255}
                                            placeholder="Digite o email"
                                            type="text"
                                            value={email}
                                            onChange={handleEmailChange}
                                        />
                                    </div>
                                </form>
                                <button className='bnt-enviarCodigo' onClick={enviarCodigoRecuperacaoSenha}>Enviar link de redefinição</button>
                                <button className='bnt-jaTenhoCodigo' onClick={irParaInserirCodigo}>Já tenho o código</button>
                            </div>
                        </>
                    )}
                </section>
            </main>

            <Rodape />

        </section>
    );
}
